// Cave84 — Floating Add Bottle button (Phase 0 Day 3)
// Mobile-only, owner-only. Sits above the BottomNav and routes to the
// /inventory/add wizard. Hidden on desktop (the inventory header carries an
// inline "Add bottle" button there).

import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.store';

export function AddBottleFAB() {
  const role = useAuthStore((s) => s.userDoc?.role);
  const navigate = useNavigate();

  if (role !== 'owner') return null;

  return (
    <button
      type="button"
      onClick={() => navigate('/inventory/add')}
      aria-label="Add bottle"
      className="md:hidden fixed right-5 bottom-[calc(env(safe-area-inset-bottom)+72px+var(--bulk-bar-h,0px))] z-30 h-14 w-14 rounded-full bg-claret hover:bg-claret-deep text-bg shadow-lg shadow-black/40 flex items-center justify-center transition-colors"
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M12 5v14" />
        <path d="M5 12h14" />
      </svg>
    </button>
  );
}
